/** FF007 — Work History Investigation (職歴調査表). */

export type YesNo = 'yes' | 'no';

export type WorkHistoryEntryStep =
  | 'siteName'
  | 'location'
  | 'contractor'
  | 'companyName'
  | 'incharge'
  | 'workPerformed'
  | 'startDate'
  | 'endDate'
  | 'dustDuration'
  | 'entrySummary';

export type PneuCheckupStep =
  | 'pneuGate'
  | 'pneu1Date'
  | 'pneu1Contractor'
  | 'pneu1Findings'
  | 'pneu1Area'
  | 'pneu2Date'
  | 'pneu2Contractor'
  | 'pneu2Findings'
  | 'pneu2Area'
  | 'pneuSectionComplete';

export type CareerHistorySurveyStep =
  | 'workHistoryIntro'
  | 'recordGate'
  | WorkHistoryEntryStep
  | 'workHistoryReview'
  | PneuCheckupStep;

export type WorkHistoryEntryDraft = {
  id: number | null;
  sortOrder: number | null;
  siteName: string;
  location: string;
  contractor: string;
  companyName: string;
  incharge: string;
  workPerformed: string;
  startDate: string;
  endDate: string;
  endDateSkipped: boolean;
  dustDuration: string;
  dustDurationYears: string;
  dustDurationMonths: string;
  dustDurationSkipped: boolean;
};

export type CompletedWorkHistoryEntry = {
  text: string;
  snapshot: WorkHistoryEntryDraft;
};

export type PneuCheckupSlotDraft = {
  id: number | null;
  checkupDate: string;
  contractor: string;
  findings: YesNo | '';
  area: string;
};

export type PneuCheckupDraft = {
  gateAnswer: YesNo | '';
  slot1: PneuCheckupSlotDraft;
  slot2: PneuCheckupSlotDraft;
  slot2Skipped: boolean;
};

export function emptyPneuSlotDraft(): PneuCheckupSlotDraft {
  return { id: null, checkupDate: '', contractor: '', findings: '', area: '' };
}

export function emptyPneuCheckupDraft(): PneuCheckupDraft {
  return {
    gateAnswer: '',
    slot1: emptyPneuSlotDraft(),
    slot2: emptyPneuSlotDraft(),
    slot2Skipped: false,
  };
}

export function emptyWorkHistoryEntryDraft(): WorkHistoryEntryDraft {
  return {
    id: null,
    sortOrder: null,
    siteName: '',
    location: '',
    contractor: '',
    companyName: '',
    incharge: '',
    workPerformed: '',
    startDate: '',
    endDate: '',
    endDateSkipped: false,
    dustDuration: '',
    dustDurationYears: '',
    dustDurationMonths: '',
    dustDurationSkipped: false,
  };
}

export const WORK_HISTORY_ENTRY_STEPS: WorkHistoryEntryStep[] = [
  'siteName',
  'location',
  'contractor',
  'companyName',
  'incharge',
  'workPerformed',
  'startDate',
  'endDate',
  'dustDuration',
  'entrySummary',
];
